Ext.ns('mx.comp');

mx.comp.HtmlFormField = Ext.extend(Ext.Panel, {
    isFormField: true,
    border: false,
    cls: 'htmlformfield',
    hideOnZeroValue: true,
    getName: function() {
        return this.name;
    },
    html: '',
    disable: Ext.emptyFn,
    autoHidden: false,
    setValue: function(v) {
        var el = Ext.get(this.el);
        if (el) {
            el.dom.innerHTML = this.renderer(v);
        }
        if (this.hideOnZeroValue && !parseFloat(v)) {
            this.hideWithLabel();
            this.autoHidden = true;
        } else if (this.autoHidden) {
            this.showWithLabel();
        }
    },
    hideWithLabel: function() {
        if (Ext.get(this.el)) {
            var el = Ext.get(this.el)
                .parent()
                .parent();
            el.setVisibilityMode(Ext.Element.DISPLAY);
            el.hide();
        }
    },
    showWithLabel: function() {
        if (Ext.get(this.el)) {
            var el = Ext.get(this.el)
                .parent()
                .parent();
            el.show();
        }
    },
    renderer: function(v) {
        return v;
    },

    // functions to bypass form processing and validation:
    validate: function() {
        return true;
    },
    isDirty: function() {
        return false;
    },
    initComponent: function() {
        this.on(
            'render',
            function() {
                if (this.parentCls) {
                    Ext.get(this.el)
                        .parent()
                        .parent()
                        .addClass(this.parentCls);
                }
            },
            this
        );
    },
});
